
// Avoid any problem with the language code.
const getLangSanitized = (lang) => {
    if (!lang) return 'es';

    if (['es', 'en'].includes(lang)) return lang;

    if (lang.toUpperCase().startsWith('ES')) return 'es';

    return 'en';
};

const state = () => ({
    lang: getLangSanitized(localStorage.getItem('lang'))
})

const mutations = {
    SET_LANG(state, lang) {
        state.lang = lang
    }
}

const actions = {
    updateLang({ commit, dispatch }, lang) {
    // Vue.prototype.$nuxt.$vuetify.lang.current
        commit('SET_LANG', lang)
        window.localStorage.setItem("lang", getLangSanitized(lang));
        // dispatch('catalog/findAllCategories', lang, { root: true })
    }

}

const getters = {
    getLang: (state) => {
        return state.lang
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
